function InteractiveEmptyState() {
	return (
		<div className="h-full w-full flex items-center justify-center">
			<div className="text-center">
				<p className="text-gray-500 text-lg">No data selected</p>
				<p className="text-gray-400 text-sm mt-2">
					Select parameters to visualize the chart
				</p>
			</div>
		</div>
	);
}

export default InteractiveEmptyState;
